import { isRelativeUrl } from 'common/link/link-utils.js';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMarkerVersionLinkUrl, IMarker } from 'types/markerCore/marker-core-type.js';
import { getWindow } from 'utilities/window.js';

export const UseUpdateLocation = () => {
  const navigate = useNavigate();

  const onClick = useCallback(
    (marker?: IMarker) => {
      const url = getMarkerVersionLinkUrl(marker);
      if (url) {
        if (isRelativeUrl(false, url)) {
          navigate(url);
        } else {
          getWindow()?.open(url, '_blank');
        }
      }
    },
    [navigate],
  );

  return { onClick };
};
